{
  "el": {
    "activity": {
      "attributes": {
        "end": "Λήξη",
        "now": "Τώρα",
        "title": "Ιστορικό"
      },
      "labels": {
        "no_activities": "Δεν υπάρχει ιστορικό ακόμα",
        "no_activities_subtitle": "Όταν κάποιος δημιουργήσει μια νέα ανακοίνωση, απόφαση, ερώτηση κ.λπ., θα το δεις εδώ.",
        "not_opened_yet": "Δεν έχει ανοιχτεί ακόμα"
      },
      "projects": {
        "announcement": {
          "create": "δημιούργησε μια ανακοίνωση."
        },
        "building": {
          "create": "δημιούργησε το κτίριο <i>'{notifiable_name}'</i>."
        },
        "document": {
          "create": "ανέβασε το έγγραφο <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "δημιούργησε το οικόπεδο <i>'{notifiable_name}'</i>."
        },
        "phase": {
          "create": "δημιούργησε τη φάση <i>'{notifiable_name}'</i>."
        },
        "published": {
          "customer": "δημοσίευσε την απόφαση <i>'{notifiable_name}'</i> για τον πελάτη.",
          "partners": "δημοσίευσε την απόφαση <i>'{notifiable_name}'</i> για τους συνεργάτες."
        },
        "question": {
          "create": "δημιούργησε την ερώτηση <i>'{notifiable_name}'</i> στο FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "δημιούργησε τον βοηθητικό χώρο <i>'{notifiable_name}'</i>.",
          "update": "ανέθεσε τον βοηθητικό χώρο <i>'{notifiable_name}'</i> σε ακίνητο."
        },
        "survey_type": {
          "create": "δημιούργησε ερωτηματολόγιο τύπου <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "ξεκίνησε τη συνομιλία <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "ανέθεσε το ακίνητο <i>'{notifiable_name}'</i> σε πελάτη.",
          "create": "δημιούργησε το ακίνητο <i>'{notifiable_name}'</i>.",
          "invisibled": "ανακάλεσε την πρόσβαση πελάτη στο ακίνητο <i>'{notifiable_name}'</i>.",
          "unassign": "κατάργησε την ανάθεση του ακινήτου <i>'{notifiable_name}'</i> από τον πελάτη.",
          "visibled": "έδωσε πρόσβαση πελάτη στο ακίνητο <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "δημιούργησε μια ανακοίνωση."
        },
        "decision": {
          "create": "δημιούργησε την απόφαση <i>'{notifiable_name}'</i>.",
          "not_interested": "δεν ενδιαφέρεται για την απόφαση <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "δημοσίευσε την απόφαση <i>'{notifiable_name}'</i> για τον πελάτη.",
            "partners": "δημοσίευσε την απόφαση <i>'{notifiable_name}'</i> για τους συνεργάτες."
          },
          "relaunched": "έκανε ξανά διαθέσιμη την απόφαση <i>'{notifiable_name}'</i>."
        },
        "decision_document": {
          "create": "ανέβασε το έγγραφο <i>'{notifiable_name}'</i> στην απόφαση <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "ενέκρινε την πρόταση <i>'{notifiable_name}'</i> στην απόφαση <i>'{group_name}'</i>.",
          "create": {
            "customer": "μοιράστηκε την πρόταση <i>'{notifiable_name}'</i> με τον πελάτη.",
            "employee": "δημιούργησε την πρόταση <i>'{notifiable_name}'</i>.",
            "partnergroup": "μοιράστηκε την πρόταση <i>'{notifiable_name}'</i> με τον συνεργάτη <i>{target_name}</i>."
          },
          "unapproved": "ανακάλεσε την έγκριση της πρότασης <i>'{notifiable_name}'</i> στην απόφαση <i>'{group_name}'</i>.",
          "updated": "ενημέρωσε την πρόταση <i>'{notifiable_name}'</i> στην απόφαση <i>'{group_name}'</i>."
        },
        "document": {
          "create": "ανέβασε το έγγραφο <i>'{notifiable_name}'</i>.",
          "destroy": "διέγραψε το έγγραφο <i>'{notifiable_name}'</i>"
        },
        "issue": {
          "approval": {
            "create": "ζήτησε την έγκριση του πελάτη.",
            "delete": "διέγραψε το αίτημα έγκρισης του πελάτη.",
            "rejected": "απέρριψε αυτή την παρατήρηση."
          },
          "approved": "ενέκρινε αυτή την παρατήρηση",
          "create": "δημιούργησε αυτή την παρατήρηση",
          "status": {
            "update": "άλλαξε την κατάσταση της παρατήρησης <i>'{notifiable_name}'</i> σε <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "αφαίρεσε την πρόταση <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "δημιούργησε την ερώτηση <i>'{notifiable_name}'</i> στο FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "ανέθεσε τον βοηθητικό χώρο <i>'{notifiable_name}'</i> σε αυτό το ακίνητο."
        },
        "survey": {
          "create": "δημιούργησε το ερωτηματολόγιο <i>'{notifiable_name}'</i>.",
          "published": "δημοσίευσε το ερωτηματολόγιο <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "ξεκίνησε τη συνομιλία <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "μετέφερε ένα μήνυμα στη συνομιλία <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "ανέθεσε το ακίνητο <i>'{notifiable_name}'</i> σε πελάτη.",
          "invisibled": "ανακάλεσε την πρόσβαση πελάτη στο ακίνητο <i>'{notifiable_name}'</i>.",
          "unassign": "κατάργησε την ανάθεση του ακινήτου <i>'{notifiable_name}'</i> από τον πελάτη.",
          "visibled": "έδωσε πρόσβαση πελάτη στο ακίνητο <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}
